<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">Module 5: SWOT Analysis</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This learning module is focused on giving you everything you need to
      complete a SWOT Analysis for your company. Your SWOT Analysis helps you
      determine your strengths, weaknesses, opportunities, and threats which you
      will then use to focus and assign resources so you can maintain a strong
      position and guard against any threats.
    </p>

    <p class="mt-6 text-lg">
      Going through this module, I will walk you through what a SWOT Analysis
      is, why it is important, and the steps you need to follow to create your
      own. You will then work on your SWOT Analysis and enter it into your One
      Page Alignment Plan. Chapter 4 of the book "Completing a SWOT Analysis" is
      provided in the Download Assets area along with a blank SWOT Table
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085001"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-2xl font-bold">5.2 What is it?</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      For each of the four components of the SWOT, I teach you the definition,
      the questions you can ask to complete, along with your actions of what you
      do with the list you create. I take you through the format of the SWOT
      Analysis Table.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085093"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-2xl font-bold">5.3 What is it Important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      You learn why each of the four components of the SWOT Analysis are
      important and how you can use it with your team and in your company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085243"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-2xl font-bold">5.4 How to Complete</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I walk you through the process of leading your team to complete a SWOT
      Analysis on your company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085383"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-2xl font-bold">5.5 Flint Inc. SWOT</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. went through each of the
      four sections to complete a SWOT Analysis and then the list of actions he
      created.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/291852515"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-2xl font-bold">5.6 Do the Work</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I review the SWOT Analysis process and provide everything
      you need to complete a SWOT Analysis on your company. I recommend you read
      the SWOT Analysis Chapter provided and print out a blank SWOT Analysis
      worksheet and start filling it in. You Can Do This!!
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085479"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-2xl font-bold">5.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. went through each of the
      four sections to complete a SWOT Analysis and then the list of actions he
      created.
    </p>
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the SWOT Analysis module. I end
      the video by giving you a brief overview of the Long-term Goals module
      which is next.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284085566"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
